import React from 'react';
import { withRouter, Link } from 'react-router';
import uniqid from 'uniqid';
import get from 'lodash/get';
import ScoredIcon from 'chameleon/ui-stack/ui/assessments/scored-icon';
import PerformanceBarPopover from 'legacy-src/components/assessment/Results/PerformanceBarPopover';
import { performanceTierStacks } from 'legacy-src/utility/progressHelpers';
import { getPriorStudentsSubdir } from 'legacy-src/utility/utils';
import AssignmentTitle from 'legacy-src/components/assignment/AssignmentTitle';

import 'legacy/src/components/apstudent/handlers/Results.scss';
import TextWithTooltip from 'chameleon/ui-stack/ui/assessments/text-with-tooltip';
import buildSectionStudents from 'chameleon/ui-stack/utilities/utils/buildSectionStudents';
import { Stack } from 'legacy-src/utility/StackedBar';
import usePerformanceTiers from 'chameleon/src/hooks/usePerformanceTiers';

const Results = (props) => {
  const {
    id,
    result = {},
    params,
    routes,
    groups = [],
    studentsBySection,
    popUpDisabled,
    onProgressBarClick,
  } = props;

  const subjectId = params.subject;

  const { performanceTiers } = usePerformanceTiers(subjectId);

  const {
    report = {},
    progress = {},
    section_id,
    sub_group_students = [],
  } = result;

  const group = groups.find((g) => g.id === section_id) || {};
  let { students } = group;
  const sectionStudents = buildSectionStudents(
    get(studentsBySection, [Number.parseInt(result.section_id, 10)], []),
    sub_group_students,
  );
  students =
    sectionStudents && sectionStudents.length > 0 ? sectionStudents : students;

  const reports = [report].filter((el) => el !== undefined);

  const stacks = performanceTierStacks(
    null,
    reports,
    performanceTiers,
    students,
  );

  const baseLink = `/${subjectId}/assessments/results/${
    result.id
  }${getPriorStudentsSubdir(routes)}`;
  const tooltipTargetId = `${id}-assignment-results`;

  const itemTitle = (result.item && result.item.title) || '';

  const ariaLabel = `Open student performance results: ${stacks.reduce(
    (a, b) => `${a}, ${b.label}: ${b.value}`,
    itemTitle,
  )}`;

  const studentUrl = `${baseLink}/students`;
  const popOverContentId = `student-performance-popover-${uniqid()}`;

  // if we get an empty report that means that all students will be in "No Results"
  const isBarClickDisabled = !report.id || popUpDisabled;

  const AssessmentLink = () =>
    result && (
      <Link to={baseLink}>
        <AssignmentTitle
          rId={result.id}
          title={itemTitle}
          optionalTitle={result.title}
          isQB={false}
          size="small"
        />
      </Link>
    );

  const { scored, student_scored, teacher_and_student_scored } = progress;
  const classHasNoStudents = (students || []).length === 0;

  const barAndScoredIcon = (
    <PerformanceBarPopover
      id={tooltipTargetId}
      stacks={stacks}
      ariaDescribedBy={popOverContentId}
      ariaLabel={ariaLabel}
      perfDetailsTitle={<AssessmentLink />}
      contentOffset="0 -2rem 0 0"
      studentUrl={studentUrl}
      resultsUrl={baseLink}
      onProgressBarClick={onProgressBarClick}
      disableNoResultsLink={false}
      disabled={isBarClickDisabled}
    />
  );

  if (classHasNoStudents) {
    return <Stack value={-1} />;
  }

  if (isBarClickDisabled) {
    return (
      <div className="student_performance_container">{barAndScoredIcon}</div>
    );
  }

  return (
    <div className="student_performance_container">
      <TextWithTooltip
        target={tooltipTargetId}
        ariaLabel="View Student Results"
        tooltip="View Student Results"
      >
        {barAndScoredIcon}
      </TextWithTooltip>
      <ScoredIcon
        teacherScored={scored}
        studentScored={student_scored}
        teacherAndStudentScored={teacher_and_student_scored}
      />
    </div>
  );
};

export default withRouter(Results);
